import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthGuard from './auth.guard';
import store from '@/store';
// TEST
import TestPage from "@/pages/TestPage/TestPage";
// END TEST

Vue.use(VueRouter);
/* pages */
const Account = () => import('@/pages/Account/Account'); // root page
const Profile = () => import('@/pages/Profile/Profile'); // root page
const Error = () => import('@/pages/Error/Error'); // root page
const Auth = () => import('@/pages/Auth/Auth'); // root page
const Reset = () => import('@/components/Auth/reset/reset.component'); // root page
const Accounting = () => import('@/pages/Accounting/Accounting'); // root page
const Statistics = () => import('@/pages/Statistics/Statistics'); // root page
const ShortPayments = () => import('@/pages/Accounting/ShortPayments/ShortPayments');
const Schedules = () => import('@/pages/Accounting/Schedules/Schedules');
const CustomerPayments = () => import('@/components/Accounting/customer-payments/customer-payments.component');
const IncomeTransactions = () => import('@/pages/Accounting/IncomeTransactions/IncomeTransactions');
const CustomerInvoiceItems = () => import('@/pages/Accounting/CustomerInvoiceItems/CustomerInvoiceItems');
const Billing = () => import('@/pages/Accounting/Billing/Billing');
const DispatchStatements = () => import('@/components/Accounting/dispatchers-st-ts/Dispatchers-st-ts.component');
const SafetyStatements = () => import('@/pages/Accounting/SafetyStatements/SafetyStatements');
const DriverStatements = () => import('@/pages/Accounting/DriverStatements/DriverStatements');
const CustomerInvoices = () => import('@/pages/Accounting/CustomerInvoices/CustomerInvoices');
const Calendar = () => import('@/pages/Accounting/Calendar/Calendar');
const Fuel = () => import('@/pages/Accounting/Fuel/Fuel');
const BonusCharge = () => import('@/pages/Accounting/BonusCharge/BonusCharge');
const Fleet = () => import('@/pages/Fleet/Fleet'); // root page
const WorkOrders = () => import('@/pages/Fleet/WorkOrders/WorkOrders');
const WorkOrdersStatistics = () => import("@/pages/Fleet/WorkOrdersStatistics/WorkOrdersStatistics");
const TrucksRoad = () => import("@/pages/Fleet/TrucksRoad/TrucksRoad");
const DispatchStatistics = () => import("@/pages/Statistics/DispatchStatistics/DispatchStatistics");
const ReportsOld = () => import('@/pages/Statistics/ReportsOld/ReportsOld');
const CustomerReports = () => import('@/pages/Statistics/Reports/Reports');
const Dispatch = () => import('@/pages/Dispatch/Dispatch'); // root page
const Trips = () => import('@/pages/Dispatch/Trips/Trips');
const TripList = () => import('@/components/Dispatch/Trips/TripList/TripList');
const Maintenance = () => import('@/pages/Maintenance/Maintenance'); // root page
const Drivers = () => import("@/pages/Maintenance/Drivers/Drivers");
const Trucks = () => import('@/pages/Maintenance/Trucks/Trucks');
const Trailers = () => import('@/pages/Maintenance/Trailers/Trailers');
const Factoring = () => import('@/pages/Maintenance/Factoring/Factoring');
const Employees = () => import('@/pages/Maintenance/Employees/Employees');
const Customers = () => import('@/pages/Maintenance/Customers/Customers');
const PotentialClient = () => import('@/pages/Maintenance/PotentialClient/PotentialClient');
const Clients = () => import('@/pages/Maintenance/Clients/Clients');
const Cities = () => import('@/pages/Maintenance/Cities/Cities');
const Brokers = () => import('@/pages/Maintenance/Brokers/Brokers');
const Users = () => import('@/pages/Maintenance/Users/Users');
const Roles = () => import('@/components/Settings/Roles/Roles');
// const LogbooksList = () => import('@/pages/Safety/LogbooksList/LogbooksList');
const LogbooksMod = () => import('@/pages/Safety/LogbooksMod/LogbooksMod');
const EmployeeWorkSchedule = () => import('@/pages/Safety/EmployeeWorkSchedule/EmployeeWorkSchedule');
const ManagerStatements = () => import('@/pages/Accounting/ManagerStatements/ManagerStatements');
const LostPayment = () => import('@/pages/Accounting/LostPayment/LostPayment');
const Safety = () => import('@/pages/Safety/Safety'); // root page
const Settings = () => import('@/pages/Settings/Settings'); // root page
const AccountSettings = () => import('@/pages/Settings/AccountSettings/AccountSettings');
const UserAccountSettings = () => import('@/pages/Settings/UserAccountSettings/UserAccountSettings.vue');
const SettingsSystem = () => import('@/pages/Settings/SettingsSystem/SettingsSystem');
const NewSettingsSystem = () => import('@/pages/Settings/NewSystemSettings/NewSystemSettings');
const UserProfile = () => import('@/pages/UserProfile/UserProfile');
const SafetyStatistic = () => import('@/pages/Statistics/SafetyStatistic/SafetyStatistic');
const UiKid = () => import('@/pages/Settings/UiKid/UiKid');

const routes = [
	{
		path: '/test',
		name: 'TestPage',
		component: TestPage,
		meta: { requiresAuth: true },
	},
	{
		path: '/ui',
		name: 'ui',
		component: UiKid,
		meta: { requiresAuth: true }
	},
	{
		path: '/profile',
		name: 'Profile',
		component: Profile,
		meta: { requiresAuth: true, routeNames: [ 'Profile' ] },
		beforeEnter: AuthGuard
	},
	{
		path: '/account',
		name: 'Account',
		component: Account,
		meta: { requiresAuth: true, routeNames: [ 'Account' ] },
		beforeEnter: AuthGuard
	},
	{
		path: '/account/user/:id',
		name: 'User',
		component: UserProfile,
		meta: { requiresAuth: true, routeNames: [ 'Account', 'User' ] },
		beforeEnter: AuthGuard
	},
	//   Dispatch
	{
		path: '/dispatch',
		name: 'Dispatch',
		component: Dispatch,
		meta: { requiresAuth: true, routeNames: [ 'Dispatch' ] },
		beforeEnter: AuthGuard,
		redirect: { name: 'TripList' },
		children: [
			{
				path: '/trips',
				name: 'TripList',
				component: Trips,
				meta: { requiresAuth: true },
				beforeEnter: AuthGuard,
				redirect: { name: 'Trips' },
				children: [
					{
						name: 'Trips',
						path: 'list',
						component: TripList,
						props: true,
						meta: { requiresAuth: true, routeNames: [ 'Trips', 'Dispatch' ], },
						beforeEnter: AuthGuard,
					}
				]
			},
		]
	},
	//   Safety
	{
		path: '/safety',
		name: 'Safety',
		component: Safety,
		meta: { requiresAuth: true },
		beforeEnter: AuthGuard,
		redirect: { name: 'Statistics' },
		children: [
			{
				name: 'ReportsOld',
				path: '/reportsOld',
				component: ReportsOld,
				props: { componentName: 'reportsOld' },
				meta: { requiresAuth: true, routeNames: [ 'Statistics', 'ReportsOld' ] },
				beforeEnter: AuthGuard
			},
			// {
			// 	name: 'Logbooks2',
			// 	path: '/logbooks2',
			// 	component: LogbooksList,
			// 	props: { componentName: 'LogbooksList' },
			// 	meta: { requiresAuth: true, routeNames: [ 'Safety', 'Logbooks' ] },
			// 	beforeEnter: AuthGuard
			// },
			{
				name: 'Logbooks',
				path: '/logbooks',
				component: LogbooksMod,
				props: { componentName: 'LogbooksMod' },
				meta: { requiresAuth: true, routeNames: [ 'Safety', 'Logbooks' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Employee work schedule',
				path: '/employee-work-schedule',
				component: EmployeeWorkSchedule,
				meta: { requiresAuth: true, routeNames: [ 'Safety', 'Employee work schedule' ] },
				beforeEnter: AuthGuard
			},
		]
	},
	// statistics
	{
		name: 'Statistics',
		path: '/statistics',
		component: Statistics,
		redirect: { name: 'Dispatch statistics' },
		meta: { requiresAuth: true, routeNames: [ 'Statistics' ] },
		children: [
			{
				name: 'Dispatch statistics',
				path: 'dispatch-statistics',
				component: DispatchStatistics,
				meta: { requiresAuth: true, routeNames: [ 'Statistics', 'Dispatch statistics' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Customer reports',
				path: 'customer-reports',
				component: CustomerReports,
				props: { componentName: 'Customer reports' },
				meta: { requiresAuth: true, routeNames: [ 'Statistics', 'Customer reports' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Safety RFM statistics',
				path: 'safety-statistics',
				component: SafetyStatistic,
				meta: { requiresAuth: true, routeNames: [ 'Statistics', 'Safety RFM statistics' ] },
				beforeEnter: AuthGuard
			},
		]
	},

	{
		name: 'Accounting',
		path: '/accounting',
		component: Accounting,
		redirect: { name: 'Customer invoices' },
		meta: { requiresAuth: true, routeNames: [ 'Accounting' ] },
		children: [
			{
				name: 'Customer invoices',
				path: 'customer-invoices',
				component: CustomerInvoices,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Customer invoices' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Customer payments',
				path: 'customer-payments',
				component: CustomerPayments,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Customer payments' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Income transactions',
				path: 'income-transactions',
				component: IncomeTransactions,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Income transactions' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Customer invoice items',
				path: 'customer-invoice-items',
				component: CustomerInvoiceItems,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Customer invoices items' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Billing',
				path: 'billing',
				component: Billing,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Billing' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Dispatchers statements',
				path: 'dispatchers-st-ts',
				component: DispatchStatements,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Dispatchers statements' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Safety statements',
				path: 'safety-st-ts',
				component: SafetyStatements,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Safety statements' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Drivers statements',
				path: 'drivers-statements',
				component: DriverStatements,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Drivers statements' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Schedules',
				path: 'schedules',
				component: Schedules,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Schedules' ] },
				beforeEnter: AuthGuard
			}, {
				name: 'Short payments',
				path: 'shortPayments',
				component: ShortPayments,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Short payments' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Scheduled payments',
				path: 'scheduled-payments',
				component: Calendar,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Scheduled payments' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Fuel',
				path: 'fuel',
				component: Fuel,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Fuel' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Bonus/charge for employee',
				path: 'bonus-charge',
				component: BonusCharge,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Bonus/charge for employee' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Manager statements',
				path: '/manager-statements',
				component: ManagerStatements,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Manager statements' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Company expenses',
				path: 'company-expenses',
				component: LostPayment,
				meta: { requiresAuth: true, routeNames: [ 'Accounting', 'Company expenses' ] },
				beforeEnter: AuthGuard
			},
		]
	},
	// fleet
	{
		path: '/fleet',
		name: 'Fleet',
		component: Fleet,
		redirect: { name: 'Work orders' },
		meta: { requiresAuth: true },
		children: [
			{
				path: '/work-orders',
				name: 'Work orders',
				component: WorkOrders,
				meta: { requiresAuth: true, routeNames: [ 'Fleet', 'Work orders' ] },
				beforeEnter: AuthGuard
			},
			{
				path: '/work-orders-statistics',
				name: 'Work orders statistics',
				component: WorkOrdersStatistics,
				meta: { requiresAuth: true, routeNames: [ 'Fleet', 'Work orders statistics' ] },
				beforeEnter: AuthGuard
			},
			{
				path: '/trucks-on-the-road',
				name: 'Trucks on the road',
				component: TrucksRoad,
				meta: { requiresAuth: false, routeNames: [ 'Fleet', 'Trucks on the road' ] },
				beforeEnter: AuthGuard
			}
		],
		beforeEnter: AuthGuard
	},
	//   Maintenance
	{
		path: '/maintenance',
		name: 'Maintenance',
		component: Maintenance,
		meta: { requiresAuth: true },
		beforeEnter: AuthGuard,
		children: [
			{
				name: 'Drivers',
				path: 'drivers',
				component: Drivers,
				props: { componentName: 'drivers' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Drivers' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Trucks',
				path: 'trucks',
				component: Trucks,
				props: { componentName: 'trucks' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Trucks' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Trailers',
				path: 'trailers',
				component: Trailers,
				props: { componentName: 'trailers' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Trailers' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Customers',
				path: 'customers',
				component: Customers,
				props: { componentName: 'customers' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Customers' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Employees',
				path: 'employees',
				component: Employees,
				props: { componentName: 'employees' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Employees' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Factoring companies',
				path: 'factoring',
				component: Factoring,
				props: { componentName: 'Factoring' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Factoring companies' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Cities',
				path: 'cities',
				component: Cities,
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Cities' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Brokers',
				path: 'brokers',
				component: Brokers,
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Brokers' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Users',
				path: 'users',
				component: Users,
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Users' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Potential client',
				path: 'potential-client',
				component: PotentialClient,
				props: { componentName: 'PotentialClient' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Potential client' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'clients',
				path: 'clients',
				component: Clients,
				props: { componentName: 'Clients' },
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Clients' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Roles',
				path: 'roles',
				component: Roles,
				meta: { requiresAuth: true, routeNames: [ 'Maintenance', 'Roles' ] },
				beforeEnter: AuthGuard
			},
		]
	},
	//   Settings
	{
		path: '/settings',
		name: 'Settings',
		component: Settings,
		redirect: { name: 'Roles' },
		meta: { requiresAuth: true },
		children: [
			{
				name: 'Account Settings',
				path: 'accounting-settings',
				component: AccountSettings,
				meta: { requiresAuth: true, routeNames: [ 'Settings', 'Account Settings' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'User Account Settings',
				path: 'user-account-settings',
				component: UserAccountSettings,
				meta: { requiresAuth: true, routeNames: [ 'Settings', 'User Account Settings' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'Old System Settings',
				path: 'old-system-settings',
				component: SettingsSystem,
				meta: { requiresAuth: true, routeNames: [ 'Settings', 'Old System Settings' ] },
				beforeEnter: AuthGuard
			},
			{
				name: 'System Settings',
				path: 'system-settings',
				component: NewSettingsSystem,
				meta: { requiresAuth: true, routeNames: [ 'Settings', 'System Settings' ] },
				beforeEnter: AuthGuard
			}
		]
	},
	//   Auth
	{
		path: '/auth',
		name: 'Auth',
		component: Auth,
		meta: { isUserAuth: true, routeNames: [ 'Auth' ] },
		beforeEnter: AuthGuard
	},
	//   Reset
	{
		path: '/reset',
		name: 'Reset',
		component: Reset,
		meta: { isPassReset: true, routeNames: [ 'Reset' ] },
		beforeEnter: AuthGuard,
	},
	{
		path: '/password/reset',
		name: 'Reset',
		component: Reset,
		meta: { isPassReset: true } // без beforeEnter: AuthGuard!
	},
	{
		path: '/password/reset/:token',
		name: 'ResetWithToken',
		component: Reset,
		meta: { isPassReset: true } // теж без guard
	},
	//   Error
	{
		name: 'Error',
		path: '*',
		meta: { routeNames: [ 'Error' ] },
		component: Error
	}
];

const options = {
	mode: 'history',
	base: process.env.BASE_URL,
	routes
};
const router = new VueRouter(options);

router.beforeEach(async(to, from, next) => {
	if (!store.state.routerInitDone) {
		await store.dispatch('onLogin');
		store.commit('SET_ROUTER_INIT', true);
	}

	if (to.path === '/') {
		if (store.getters.isCustomers) {
			return next({ name: 'Profile' });
		} 
		return next({ name: 'Account' });
		
	}

	next();
});

export default router;
